// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monaco-editor {
  padding-bottom: 5.6px;
  font-family: var(--theia-code-font-family);
  font-size: inherit !important;
}

#quick-input-container {
  position: fixed;
  right: 50%;
  z-index: 1000000;
}

/*
 * set z-index to 0, so tabs are not above overlay widgets
 */
.p-TabBar.theia-app-centers {
  z-index: 0;
  display: flex;
}

.monaco-editor .zone-widget {
  position: absolute;
  z-index: 10;
}

.monaco-editor .zone-widget .zone-widget-container {
  border-top-style: solid;
  border-bottom-style: solid;
  border-top-width: 0;
  border-bottom-width: 0;
  border-top-color: var(--theia-peekView-border);
  border-bottom-color: var(--theia-peekView-border);
  position: relative;
}

.monaco-editor .parameter-hints-widget > .wrapper {
  overflow: hidden;
}

/* List highlight, see https://github.com/microsoft/vscode/blob/ff5f581425da6230b6f9216ecf19abf6c9d285a6/src/vs/workbench/browser/style.ts#L50 */
.monaco-tree .monaco-tree-row .monaco-highlighted-label .highlight,
.monaco-list .monaco-list-row .monaco-highlighted-label .highlight {
  color: var(--theia-list-highlightForeground) !important;
}

/* Scrollbars, see https://github.com/microsoft/vscode/blob/ff5f581425da6230b6f9216ecf19abf6c9d285a6/src/vs/workbench/browser/style.ts#L65 */
.monaco-scrollable-element > .shadow.top {
  box-shadow: var(--theia-scrollbar-shadow) 0 6px 6px -6px inset !important;
}

.monaco-scrollable-element > .shadow.left {
  box-shadow: var(--theia-scrollbar-shadow) 6px 0 6px -6px inset !important;
}

.monaco-scrollable-element > .shadow.top.left {
  box-shadow: var(--theia-scrollbar-shadow) 6px 6px 6px -6px inset !important;
}

.monaco-scrollable-element > .scrollbar > .slider {
  background: var(--theia-scrollbarSlider-background) !important;
}

.monaco-scrollable-element > .scrollbar > .slider:hover {
  background: var(--theia-scrollbarSlider-hoverBackground) !important;
}

.monaco-scrollable-element > .scrollbar > .slider.active {
  background: var(--theia-scrollbarSlider-activeBackground) !important;
}

.monaco-editor .codicon.codicon-debug-start {
  color: var(--theia-debugIcon-startForeground) !important;
}

.monaco-editor .codelens-decoration a {
  color: inherit !important;
}

.monaco-editor .reference-zone-widget .ref-tree .referenceMatch .highlight {
  color: unset !important;
}

.monaco-editor .find-widget .monaco-inputbox.synthetic-focus {
  outline: var(--theia-border-width) solid;
  outline-offset: calc(-1 * var(--theia-border-width));
  outline-color: var(--theia-focusBorder);
}

.monaco-editor .rename-box input {
  color: var(--theia-editor-foreground);
}

.monaco-editor .rename-box .rename-label {
  opacity: 0.8;
  padding: 3px;
  font-family: sans-serif;
}

/* Monaco Quick Input */
.quick-input-widget {
  background-color: var(--theia-quickInput-background) !important;
  color: var(--theia-foreground) !important;
}

.quick-input-list .monaco-list-row.focused {
  background-color: var(--theia-quickInputList-focusBackground) !important;
}

.quick-input-list .monaco-keybinding > .monaco-keybinding-key {
  color: inherit !important;
}

.quick-input-list .monaco-list-row.focused,
.quick-input-list .monaco-list-row.focused .monaco-highlighted-label,
.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .codicon,
.quick-input-list .monaco-list-row.focused .quick-input-list-entry .quick-input-list-separator,
.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .monaco-keybinding .monaco-keybinding-key,
.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .monaco-keybinding .monaco-keybinding-key-separator {
  color: var(--theia-quickInputList-focusForeground) !important;
}

.quick-input-list .monaco-list-row .codicon {
  color: var(--theia-foreground) !important;
}

.quick-input-list .monaco-list-row.focused .codicon {
  color: var(--theia-list-foreground) !important;
}

.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .highlight {
  color: var(--theia-list-focusHighlightForeground) !important;
}

.quick-input-titlebar .action-item .action-label {
    color: var(--theia-foreground) !important;
}

.monaco-list-rows
  .monaco-list-row:not(:first-child)
  .quick-input-list-entry.quick-input-list-separator-border {
  border-top: 1px solid var(--theia-pickerGroup-border) !important;
}
.quick-input-list .quick-input-list-separator {
  color: var(--theia-pickerGroup-foreground) !important;
}

.monaco-icon-label > .monaco-icon-label-container {
  flex: 1;
}

.quick-input-list-rows
  .quick-input-list-row
  .monaco-icon-label
  .monaco-icon-description-container
  .label-description {
    font-family: var(--theia-ui-font-family);
    font-size: calc(var(--theia-ui-font-size1) * 0.9) !important;
    color: var(--theia-foreground) !important;
    white-space: inherit;
}

.quick-input-list-rows
  .quick-input-list-row
  .monaco-icon-label
  .monaco-icon-label-container
  .monaco-icon-name-container
  .label-name {
    font-family: var(--theia-ui-font-family);
    font-size: var(--theia-ui-font-size1) !important;
    color: var(--theia-foreground) !important;
}

.quick-input-list .monaco-icon-label.codicon,
.quick-input-list .monaco-icon-label.file-icon {
  display: flex;
  text-align: left;
}

.quick-input-list .monaco-icon-label::before {
  height: 22px;
}

.codicon-file.default-file-icon.file-icon {
  padding-left: 2px;
  height: 22px;
}

.codicon-file.default-file-icon.file-icon::before {
  margin-right: 4px;
  font-size: var(--theia-ui-font-size1);
}

.quick-input-list .monaco-icon-label.codicon::before {
  position: relative;
  top: 3px;
}

.quick-input-list .monaco-icon-label.theia-file-icons-js {
  line-height: inherit;
}

.quick-input-list .quick-input-list-label {
  cursor: pointer !important;
}

.quick-input-progress.active.infinite {
    background-color: var(--theia-progressBar-background);
    width: 3%;
    /* \`progress-animation\` is defined in \`packages/core/src/browser/style/progress-bar.css\` */
    animation: progress-animation 1.3s 0s infinite cubic-bezier(0.645, 0.045, 0.355, 1);
}

.monaco-list:not(.drop-target) .monaco-list-row:hover:not(.selected):not(.focused) {
  background: var(--theia-list-hoverBackground);
}

.monaco-editor .peekview-widget .head .peekview-title {
  font-family: var(--theia-ui-font-family);
}

.monaco-editor .peekview-widget .referenceMatch {
  font-family: var(--theia-ui-font-family);
}

.monaco-editor .find-widget .monaco-findInput .input,
.monaco-editor .find-widget .matchesCount {
  font-family: var(--theia-ui-font-family);
}

.monaco-editor .monaco-action-bar .action-label.codicon {
  color: var(--theia-foreground);
}

.monaco-editor .monaco-action-bar .action-item.active {
	transform: none;
}

.monaco-editor .peekview-widget .monaco-list-row.focused.selected .label-name,
.monaco-editor .peekview-widget .monaco-list-row.focused.selected .label-description,
.monaco-editor .peekview-widget .monaco-list-row.focused.selected .monaco-highlighted-label,
.monaco-editor .peekview-widget .monaco-list-row.focused.selected .codicon {
  color: var(--theia-list-activeSelectionForeground) !important;
}

.quick-input-titlebar {
  background-color: var(--theia-quickInputTitle-background);
}

.quick-input-widget input {
  background-color: var(--theia-input-background) !important;
}

.monaco-editor .suggest-widget .monaco-list .monaco-list-row.focused>.contents>.main .monaco-highlighted-label .highlight {
    color: var(--vscode-editorSuggestWidget-focusHighlightForeground) !important;
}

.symbol-icon-center {
  align-self: center;
  margin-right: 4px;
}

.monaco-inputbox.error > .ibwrapper > .input,
.monaco-inputbox.warning > .ibwrapper > .input,
.monaco-inputbox.info > .ibwrapper > .input {
    outline: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/monaco/src/browser/style/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;EAC9C,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gJAAgJ;AAChJ;;EAEE,uDAAuD;AACzD;;AAEA,4IAA4I;AAC5I;EACE,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,oDAAoD;EACpD,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,+DAA+D;EAC/D,yCAAyC;AAC3C;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,6DAA6D;AAC/D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;;EAGE,gEAAgE;AAClE;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,OAAO;AACT;;AAEA;;;;;IAKI,wCAAwC;IACxC,4DAA4D;IAC5D,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;;;;;;IAMI,wCAAwC;IACxC,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,qDAAqD;IACrD,SAAS;IACT,0FAA0F;IAC1F,mFAAmF;AACvF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;EAIE,6DAA6D;AAC/D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;IACI,4EAA4E;AAChF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;IAGI,qBAAqB;AACzB","sourcesContent":[".monaco-editor {\n  padding-bottom: 5.6px;\n  font-family: var(--theia-code-font-family);\n  font-size: inherit !important;\n}\n\n#quick-input-container {\n  position: fixed;\n  right: 50%;\n  z-index: 1000000;\n}\n\n/*\n * set z-index to 0, so tabs are not above overlay widgets\n */\n.p-TabBar.theia-app-centers {\n  z-index: 0;\n  display: flex;\n}\n\n.monaco-editor .zone-widget {\n  position: absolute;\n  z-index: 10;\n}\n\n.monaco-editor .zone-widget .zone-widget-container {\n  border-top-style: solid;\n  border-bottom-style: solid;\n  border-top-width: 0;\n  border-bottom-width: 0;\n  border-top-color: var(--theia-peekView-border);\n  border-bottom-color: var(--theia-peekView-border);\n  position: relative;\n}\n\n.monaco-editor .parameter-hints-widget > .wrapper {\n  overflow: hidden;\n}\n\n/* List highlight, see https://github.com/microsoft/vscode/blob/ff5f581425da6230b6f9216ecf19abf6c9d285a6/src/vs/workbench/browser/style.ts#L50 */\n.monaco-tree .monaco-tree-row .monaco-highlighted-label .highlight,\n.monaco-list .monaco-list-row .monaco-highlighted-label .highlight {\n  color: var(--theia-list-highlightForeground) !important;\n}\n\n/* Scrollbars, see https://github.com/microsoft/vscode/blob/ff5f581425da6230b6f9216ecf19abf6c9d285a6/src/vs/workbench/browser/style.ts#L65 */\n.monaco-scrollable-element > .shadow.top {\n  box-shadow: var(--theia-scrollbar-shadow) 0 6px 6px -6px inset !important;\n}\n\n.monaco-scrollable-element > .shadow.left {\n  box-shadow: var(--theia-scrollbar-shadow) 6px 0 6px -6px inset !important;\n}\n\n.monaco-scrollable-element > .shadow.top.left {\n  box-shadow: var(--theia-scrollbar-shadow) 6px 6px 6px -6px inset !important;\n}\n\n.monaco-scrollable-element > .scrollbar > .slider {\n  background: var(--theia-scrollbarSlider-background) !important;\n}\n\n.monaco-scrollable-element > .scrollbar > .slider:hover {\n  background: var(--theia-scrollbarSlider-hoverBackground) !important;\n}\n\n.monaco-scrollable-element > .scrollbar > .slider.active {\n  background: var(--theia-scrollbarSlider-activeBackground) !important;\n}\n\n.monaco-editor .codicon.codicon-debug-start {\n  color: var(--theia-debugIcon-startForeground) !important;\n}\n\n.monaco-editor .codelens-decoration a {\n  color: inherit !important;\n}\n\n.monaco-editor .reference-zone-widget .ref-tree .referenceMatch .highlight {\n  color: unset !important;\n}\n\n.monaco-editor .find-widget .monaco-inputbox.synthetic-focus {\n  outline: var(--theia-border-width) solid;\n  outline-offset: calc(-1 * var(--theia-border-width));\n  outline-color: var(--theia-focusBorder);\n}\n\n.monaco-editor .rename-box input {\n  color: var(--theia-editor-foreground);\n}\n\n.monaco-editor .rename-box .rename-label {\n  opacity: 0.8;\n  padding: 3px;\n  font-family: sans-serif;\n}\n\n/* Monaco Quick Input */\n.quick-input-widget {\n  background-color: var(--theia-quickInput-background) !important;\n  color: var(--theia-foreground) !important;\n}\n\n.quick-input-list .monaco-list-row.focused {\n  background-color: var(--theia-quickInputList-focusBackground) !important;\n}\n\n.quick-input-list .monaco-keybinding > .monaco-keybinding-key {\n  color: inherit !important;\n}\n\n.quick-input-list .monaco-list-row.focused,\n.quick-input-list .monaco-list-row.focused .monaco-highlighted-label,\n.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .codicon,\n.quick-input-list .monaco-list-row.focused .quick-input-list-entry .quick-input-list-separator,\n.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .monaco-keybinding .monaco-keybinding-key,\n.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .monaco-keybinding .monaco-keybinding-key-separator {\n  color: var(--theia-quickInputList-focusForeground) !important;\n}\n\n.quick-input-list .monaco-list-row .codicon {\n  color: var(--theia-foreground) !important;\n}\n\n.quick-input-list .monaco-list-row.focused .codicon {\n  color: var(--theia-list-foreground) !important;\n}\n\n.quick-input-list .monaco-list-row.focused .monaco-highlighted-label .highlight {\n  color: var(--theia-list-focusHighlightForeground) !important;\n}\n\n.quick-input-titlebar .action-item .action-label {\n    color: var(--theia-foreground) !important;\n}\n\n.monaco-list-rows\n  .monaco-list-row:not(:first-child)\n  .quick-input-list-entry.quick-input-list-separator-border {\n  border-top: 1px solid var(--theia-pickerGroup-border) !important;\n}\n.quick-input-list .quick-input-list-separator {\n  color: var(--theia-pickerGroup-foreground) !important;\n}\n\n.monaco-icon-label > .monaco-icon-label-container {\n  flex: 1;\n}\n\n.quick-input-list-rows\n  .quick-input-list-row\n  .monaco-icon-label\n  .monaco-icon-description-container\n  .label-description {\n    font-family: var(--theia-ui-font-family);\n    font-size: calc(var(--theia-ui-font-size1) * 0.9) !important;\n    color: var(--theia-foreground) !important;\n    white-space: inherit;\n}\n\n.quick-input-list-rows\n  .quick-input-list-row\n  .monaco-icon-label\n  .monaco-icon-label-container\n  .monaco-icon-name-container\n  .label-name {\n    font-family: var(--theia-ui-font-family);\n    font-size: var(--theia-ui-font-size1) !important;\n    color: var(--theia-foreground) !important;\n}\n\n.quick-input-list .monaco-icon-label.codicon,\n.quick-input-list .monaco-icon-label.file-icon {\n  display: flex;\n  text-align: left;\n}\n\n.quick-input-list .monaco-icon-label::before {\n  height: 22px;\n}\n\n.codicon-file.default-file-icon.file-icon {\n  padding-left: 2px;\n  height: 22px;\n}\n\n.codicon-file.default-file-icon.file-icon::before {\n  margin-right: 4px;\n  font-size: var(--theia-ui-font-size1);\n}\n\n.quick-input-list .monaco-icon-label.codicon::before {\n  position: relative;\n  top: 3px;\n}\n\n.quick-input-list .monaco-icon-label.theia-file-icons-js {\n  line-height: inherit;\n}\n\n.quick-input-list .quick-input-list-label {\n  cursor: pointer !important;\n}\n\n.quick-input-progress.active.infinite {\n    background-color: var(--theia-progressBar-background);\n    width: 3%;\n    /* `progress-animation` is defined in `packages/core/src/browser/style/progress-bar.css` */\n    animation: progress-animation 1.3s 0s infinite cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.monaco-list:not(.drop-target) .monaco-list-row:hover:not(.selected):not(.focused) {\n  background: var(--theia-list-hoverBackground);\n}\n\n.monaco-editor .peekview-widget .head .peekview-title {\n  font-family: var(--theia-ui-font-family);\n}\n\n.monaco-editor .peekview-widget .referenceMatch {\n  font-family: var(--theia-ui-font-family);\n}\n\n.monaco-editor .find-widget .monaco-findInput .input,\n.monaco-editor .find-widget .matchesCount {\n  font-family: var(--theia-ui-font-family);\n}\n\n.monaco-editor .monaco-action-bar .action-label.codicon {\n  color: var(--theia-foreground);\n}\n\n.monaco-editor .monaco-action-bar .action-item.active {\n\ttransform: none;\n}\n\n.monaco-editor .peekview-widget .monaco-list-row.focused.selected .label-name,\n.monaco-editor .peekview-widget .monaco-list-row.focused.selected .label-description,\n.monaco-editor .peekview-widget .monaco-list-row.focused.selected .monaco-highlighted-label,\n.monaco-editor .peekview-widget .monaco-list-row.focused.selected .codicon {\n  color: var(--theia-list-activeSelectionForeground) !important;\n}\n\n.quick-input-titlebar {\n  background-color: var(--theia-quickInputTitle-background);\n}\n\n.quick-input-widget input {\n  background-color: var(--theia-input-background) !important;\n}\n\n.monaco-editor .suggest-widget .monaco-list .monaco-list-row.focused>.contents>.main .monaco-highlighted-label .highlight {\n    color: var(--vscode-editorSuggestWidget-focusHighlightForeground) !important;\n}\n\n.symbol-icon-center {\n  align-self: center;\n  margin-right: 4px;\n}\n\n.monaco-inputbox.error > .ibwrapper > .input,\n.monaco-inputbox.warning > .ibwrapper > .input,\n.monaco-inputbox.info > .ibwrapper > .input {\n    outline: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
